export default __webpack_public_path__ + "static/solicitingOpinion-45273778a071eee70e8f18f65cfdfce2.svg";